import type {
  Metrics,
  OverallPerformance,
  Product,
  ProductClasses,
  Products,
  Project,
  Projects,
  Training,
  Trainings,
  TrainingStatus,
  TrainingTest,
  TrainingTests,
  TrainingTestStatus,
} from './store.types'

interface RunStatusTrainings {
  eventType: 'TRAINING_UPDATE'
  accuracy?: number
  metrics: Metrics
  overallPerformance?: OverallPerformance
  status: TrainingStatus
  trainingId: number
  outputFileStatus: 'AVAILABLE' | 'NOT_AVAILABLE'
}

interface RunStatusTests {
  eventType: 'TRAINING_TEST_UPDATE'
  performance?: number
  metrics: Metrics
  overallPerformance?: OverallPerformance
  status: TrainingTestStatus
  trainingId: number
  trainingTestId: number
}

export type RunStatus = RunStatusTrainings | RunStatusTests

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ActionMap<M extends { [index: string]: any }> = {
  [Key in keyof M]: M[Key] extends undefined
    ? {
        type: Key
      }
    : {
        type: Key
        payload: M[Key]
      }
}

interface AlertNotificationImageUpload {
  eventType: 'IMAGE_UPLOAD_UPDATE'
  uploadId: string
  progress?: number
  status:
    | 'ERROR'
    | 'PREPARING_UPLOAD'
    | 'SAVING_IMAGES'
    | 'ANALYZING_IMAGES'
    | 'PERSISTING_DATA'
    | 'COMPLETED' // BE completed
    | 'UPDATING_UI'
    | 'COMPLETED_UPDATING_UI'
  observationsId?: number[]
  datasetId?: string
}

export type AlertNotification = AlertNotificationImageUpload

export enum Types {
  FetchProjects = 'FETCH_PROJECTS',
  FetchMoreProjects = 'FETCH_MORE_PROJECTS',
  EmptyProjects = 'EMPTY_PROJECTS',
  FetchProject = 'FETCH_PROJECT',
  CreateProject = 'CREATE_PROJECT',
  UpdateProject = 'UPDATE_PROJECT',
  DeleteProject = 'DELETE_PROJECT',
  FetchProducts = 'FETCH_PRODUCTS',
  FetchMoreProducts = 'FETCH_MORE_PRODUCTS',
  EmptyProducts = 'EMPTY_PRODUCTS',
  SetProduct = 'SET_PRODUCT',
  CreateProduct = 'CREATE_PRODUCT',
  UpdateProduct = 'UPDATE_PRODUCT',
  DeleteProduct = 'DELETE_PRODUCT',
  FetchProductClasses = 'FETCH_PRODUCT_CLASSES',
  EmptyProductClasses = 'EMPTY_PRODUCT_CLASSES',
  FetchTrainings = 'FETCH_TRAININGS',
  FetchMoreTrainings = 'FETCH_MORE_TRAININGS',
  EmptyTrainings = 'EMPTY_TRAININGS',
  SetTraining = 'SET_TRAINING',
  DeleteTraining = 'DELETE_TRAINING',
  UpdateTrainingStatus = 'UPDATE_TRAINING_STATUS',
  FetchTrainingTests = 'FETCH_TRAINING_TESTS',
  FetchMoreTrainingTests = 'FETCH_MORE_TRAINING_TESTS',
  EmptyTrainingTests = 'EMPTY_TRAINING_TESTS',
  SetTrainingTest = 'SET_TRAINING_TEST',
  DeleteTrainingTest = 'DELETE_TRAINING_TEST',
  UpdateTrainingTestStatus = 'UPDATE_TRAINING_TEST_STATUS',
  AlertNotificationImageUpload = 'UPDATE_ALERT_NOTIFICATION_IMAGE_UPLOAD',
}

export type Payload = {
  [Types.FetchProjects]: Projects
  [Types.FetchMoreProjects]: Projects
  [Types.EmptyProjects]: undefined
  [Types.FetchProject]: Project
  [Types.CreateProject]: Project
  [Types.UpdateProject]: Project
  [Types.DeleteProject]: number
  [Types.FetchProducts]: Products
  [Types.FetchMoreProducts]: Products
  [Types.EmptyProducts]: undefined
  [Types.SetProduct]: Product
  [Types.CreateProduct]: Product
  [Types.UpdateProduct]: Product
  [Types.DeleteProduct]: number
  [Types.FetchProductClasses]: ProductClasses
  [Types.EmptyProductClasses]: undefined
  [Types.FetchTrainings]: Trainings
  [Types.FetchMoreTrainings]: Trainings
  [Types.EmptyTrainings]: undefined
  [Types.SetTraining]: Training
  [Types.DeleteTraining]: number
  [Types.UpdateTrainingStatus]: RunStatusTrainings
  [Types.FetchTrainingTests]: TrainingTests
  [Types.FetchMoreTrainingTests]: TrainingTests
  [Types.EmptyTrainingTests]: undefined
  [Types.SetTrainingTest]: TrainingTest
  [Types.DeleteTrainingTest]: number
  [Types.UpdateTrainingTestStatus]: RunStatusTests
  [Types.AlertNotificationImageUpload]: AlertNotification
}

export type Actions = ActionMap<Payload>[keyof ActionMap<Payload>]
